/**
 * Cluster Reply showcase data – single source for search and grounding tools.
 */

export {
  CLUSTER_REPLY_KNOWLEDGE_BASE,
  getClusterReplyChunkById,
  getClusterReplyAllChunks,
  type ClusterReplyChunk
} from './knowledge-base';
